
<app-icon>help</app-icon>

<div class="ed-popup" #content>
  <ng-content/>
</div>
